import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';

/**
 * @param {object} props
 * @param {number} props.stepNumber
 * @returns {JSX.Element}
 */
export const ShopperBulletServiceOverride = ({ stepNumber }) => (
  <Text formattedMessageValues={{ stepNumber }} textType={TextType.H4} value={messages.shopperBulletServiceOverride} />
);
